// Copy for the head-covering chip on the person card (shared people step of both create flows).
import type { MangaCharacterDraft } from './types';

// The covering is already a short sanitised phrase from the photo analysis (utils/manga/head-covering.ts).

function possessive(gender: string): 'her' | 'his' | 'their' {
  const g = String(gender || '').toLowerCase();
  if (g === 'girl' || g === 'woman') return 'her';
  if (g === 'boy' || g === 'man') return 'his';
  return 'their';
}

/** "Keeps her beige hijab on every page" (her/his/their from the card's gender). */
export function headCoveringChipText(gender: string, covering: string): string {
  return `Keeps ${possessive(gender)} ${covering} on every page`;
}

/** Accessible name of the chip's remove button: "Remove the beige hijab". */
export function headCoveringRemoveLabel(covering: string): string {
  return `Remove the ${covering}`;
}

/** The gender to word the chip by: only when the analysis or the parent set it (the card defaults to 'boy'). */
export function chipGender(c: Pick<MangaCharacterDraft, 'gender' | 'genderKnown'>): string {
  return c.genderKnown ? c.gender : '';
}

/** The patch for the card's gender select: the parent's choice counts as known. */
export function pickedGender(gender: string): Pick<MangaCharacterDraft, 'gender' | 'genderKnown'> {
  return { gender, genderKnown: true };
}

/** The ✕ on the chip: drop headCovering from that person only (the server reads it only from the request). */
export function clearHeadCovering(characters: MangaCharacterDraft[], id: string): MangaCharacterDraft[] {
  return characters.map((c) => {
    if (c.id !== id) return c;
    const { headCovering: _removed, ...rest } = c;
    return rest;
  });
}
